import { useApiMutation } from "./use-api-mutation";

export default function useGetCommentAttachmentPresignedUrl() {
	return useApiMutation(
		"post",
		"/shops/{shopId}/return-requests/{returnRequestId}/comments/attachments/presigned-url",
		{
			notify: false,
			onError(error) {
				console.error(error);
			},
		},
	);
}
